import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from '../components/auth/useAuth'
import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getDashboard } from '../actions/sesameActions'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import {CardSimple} from '../components/design/Cards/CardSimple'
import Loader from '../components/loaders/Loader'

export default function Dashboard() { 
  	const { t } = useTranslation()
	const {clientauth} = useAuth()
	const dispatch = useDispatch()

    const { sesamedata, loadingSesame } = useSelector(state => state.sesame)

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(clientauth && clientauth?.email){
            dispatch(getDashboard())
        }
    },[clientauth])

	return (
        <Container fluid className='contenido p-5'>
            <Row>
                <Col>
                    <h1>{t('dashboard.welcome')} {clientauth?.name}</h1>
                    <h3>{t('dashboard.description')}</h3>
                </Col>
            </Row>
            {loadingSesame ?
                <Loader />
            :
                <>
                    <Row className='mt-5'>
                        <Col xs={12} md={12}>
                            <Row>
                                <Col xs={12}>
                                    <h3><img src="/images/sesame.svg" alt="sesame" width={30} className='me-2'></img>{t('sesame.sesameData')}</h3>
                                    <Row>
                                        <Col xs={12} md={3} className='d-flex'>
                                            <CardSimple
                                                icon="/images/time.svg"
                                                title={t('sesame.hoursToday')}
                                                numbers={
                                                    sesamedata?.hoursToday ?
                                                        sesamedata.hoursToday
                                                    :
                                                        null
                                                }
                                                texts={
                                                    sesamedata?.hoursToday ?
                                                        null
                                                    :
                                                        t('sesame.noHoursToday')
                                                }
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className='d-flex'>
                                            <CardSimple
                                                icon="/images/calendar.svg"
                                                title={t('sesame.calendarWeekly')}
                                                numbers={
                                                    sesamedata?.schedule ?
                                                        sesamedata?.schedule?.range || sesamedata?.schedule?.label
                                                    :
                                                        null
                                                }
                                                texts={
                                                    sesamedata?.hoursToday ?
                                                        null
                                                    :
                                                        t('sesame.noSchedule')
                                                }
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className='d-flex'>
                                            <CardSimple
                                                icon="/images/calendarempty.svg"
                                                title={t('sesame.vacationsDaysEnjoyed')}
                                                texts={
                                                    sesamedata?.vacations && sesamedata?.vacations.length > 0 ? (
                                                        sesamedata?.vacations.map((v, i) => (
                                                            <div key={i}>
                                                                {v.start === v.end
                                                                    ? new Date(v.start).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })
                                                                    : `${new Date(v.start).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })} - ${new Date(v.end).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}`
                                                                }
                                                            </div>
                                                        ))
                                                    ) : (
                                                        t('sesame.noVacationsDays')
                                                    )
                                                }
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className='d-flex'>
                                            <CardSimple
                                                icon="/images/calendarempty.svg"
                                                title={t('sesame.vacationsDays')}
                                                texts={
                                                sesamedata?.vacationStats && (
                                                    <>
                                                        <div>{sesamedata.vacationStats.name}</div>
                                                        <div>
                                                            {sesamedata.vacationStats.available} {t('sesame.availables')}
                                                        </div>
                                                        <div>
                                                            {sesamedata.vacationStats.pending} {t('sesame.pending')}
                                                        </div>
                                                    </>
                                                )}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='mt-5'>
                        <Col xs={12}>
                            <h3>{t('sesame.weeklyHours')}</h3>
                            <Card className='card-simple'>

                                <div style={{ width: "100%", height: 300 }}>
                                    <ResponsiveContainer>
                                        <BarChart data={sesamedata?.weekly || []} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                            <XAxis dataKey="day" />
                                            <YAxis />
                                            <Tooltip formatter={(value) => `${Math.floor(value)}h ${Math.round((value % 1) * 60)}m`} />
                                            <Bar dataKey="hours" fill="#000" />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </Card>
                        </Col>
                        <Col xs={12} md={4}>

                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col xs={12} md={4} className="mt-2 d-flex">
                            <Link to="https://app.sesametime.com/" className='link w-100'>
                                <Card className='card-simple h-100'>
                                    <Card.Body className='p-4'>
                                        <div className='d-flex justify-content-between align-items-start mb-3'>
                                            <img src="/images/sesame.svg" alt="sesame" className='logo-sso' />
                                            <img src="/images/link-external.svg" alt="link sesame" />
                                        </div>
                                        <h4>{t('sesame.title')}</h4>
                                        {t('sesame.claim')}
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4} className="mt-2 d-flex">
                            <Link to="https://iseazy.com/es/login-saml" className='link w-100'>
                                <Card className='card-simple h-100'>
                                    <Card.Body className='py-4'>
                                        <div className='d-flex justify-content-between align-items-start mb-3'>
                                            <img src="/images/iseazy.svg" alt="iseazy" className='logo-sso' />
                                            <img src="/images/link-external.svg" alt="link iseazy" />
                                        </div>
                                        <h4>{t('iseazy.title')}</h4>
                                        {t('iseazy.claim')}
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4} className="mt-2 d-flex">
                            <Link to="https://outlook.office.com/mail/0/" className='link w-100'>
                                <Card className='card-simple h-100'>
                                    <Card.Body className='py-4'>
                                        <div className='d-flex justify-content-between align-items-start mb-3'>
                                            <img src="/images/outlook.svg" alt="outlook" className='logo-sso' />
                                            <img src="/images/link-external.svg" alt="link outlook" />
                                        </div>
                                        <h4>{t('outlook.title')}</h4>
                                        {t('outlook.claim')}
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4} className="mt-2 d-flex">
                            <Link to="https://teams.microsoft.com/" className='link w-100'>
                                <Card className='card-simple h-100'>
                                    <Card.Body className='py-4'>
                                        <div className='d-flex justify-content-between align-items-start mb-3'>
                                            <img src="/images/teams.svg" alt="teams" className='logo-sso' />
                                            <img src="/images/link-external.svg" alt="link teams" />
                                        </div>
                                        <h4>{t('teams.title')}</h4>
                                        {t('teams.claim')}
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4} className="mt-2 d-flex">
                            <Link to={`/${t("url."+clientauth?.rol)}/${t("url.odoo")}`} className='link w-100'>
                                <Card className='card-simple h-100'>
                                    <Card.Body className='py-4'>
                                        <div className='d-flex justify-content-between align-items-start mb-3'>
                                            <img src="/images/odoo.svg" alt="odoo" className='logo-sso' />
                                            <img src="/images/link-external.svg" alt="link odoo" />
                                        </div>
                                        <h4>{t('odoo.title')}</h4>
                                        {t('odoo.claim')}
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} md={4} className="mt-2 d-flex">
                            <Link to={`/${t("url."+clientauth?.rol)}/${t("url.chatbot")}`} className='link w-100'>
                                <Card className='card-simple h-100'>
                                    <Card.Body className='py-4'>
                                        <div className='d-flex justify-content-between align-items-start mb-3'>
                                            <img src="/images/chatbot.svg" alt="chatbot" className='logo-sso' />
                                            <img src="/images/link-external.svg" alt="link chatbot" />
                                        </div>
                                        <h4>{t('chatbot.title')}</h4>
                                        {t('chatbot.claim')}
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                    </Row>
                </>
            }

        </Container>
	)
}